<template>
  <v-card class="pa-4 px-6" flat>
    <v-row v-if="queue.text" no-gutters class="pt-4"
      ><span v-html="queue.text"></span
    ></v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["queue"]),
  },
};
</script>

<style scoped>
.title-information {
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.25px;
  text-align: left;
  font-weight: bold;
}
</style>
